import { render, staticRenderFns } from "./PurcharseOrdersView.vue?vue&type=template&id=1c381aac&lang=pug&"
import script from "./PurcharseOrdersView.vue?vue&type=script&lang=js&"
export * from "./PurcharseOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./PurcharseOrdersView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports